import { forwardRef } from 'react';
import type { VimeoCustomAction } from 'autogen/swagger/all';
import useVimeoQuickView from 'components/video/hooks/useVimeoQuickView';
import { CustomActionButton } from '../shared/styles';
import type { CustomActionProps } from '../shared/types';

type VimeoAction = { action: VimeoCustomAction } & CustomActionProps;

const VimeoAction = forwardRef<HTMLButtonElement, VimeoAction>(({ action, onClick, ...restProps }, ref) => {
    const [, openVimeoQuickView] = useVimeoQuickView();

    return (
        <CustomActionButton
            ref={ref}
            type="button"
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
                openVimeoQuickView({
                    isOpen: true,
                    video: { id: action.vimeoId, platform: 'Vimeo', url: action.videoUrl }
                });
            }}
            {...restProps}
        />
    );
});

export default VimeoAction;
